import Alpine from 'alpinejs';
import servicesSlider from "../../scripts/_servicesSlider";
import cardSlider from "../../scripts/_cardSlider";
import featureWheel from "../../scripts/_featureWheel";
import imageMap from "../../scripts/_imageMap";
import cookieConsentBanner from '../cookie-consent-banner';

// @ts-ignore
window.Alpine = Alpine;

// Alpine.js components
Alpine.data('cardSlider', cardSlider);
Alpine.data('featureWheel', featureWheel);
Alpine.data('servicesSlider', servicesSlider); 
Alpine.data('imageMap', imageMap); 
Alpine.data('cookieConsent', cookieConsentBanner);

Alpine.start(); 